import IconSortArrowUp from '@/components/icons/IconSortArrowUp'
import IconColorSortArrowUp from '@/components/icons/IconColorSortArrowUp'
import './SortingIndicator.css'

const getIndicatorComponent = isActive =>
  isActive ? IconColorSortArrowUp : IconSortArrowUp

export default function SortingIndicator({ isActive, order }) {
  const isAscending = isActive && order === 'ascending'
  const isDescending = isActive && order === 'descending'
  const AscendingIndicator = getIndicatorComponent(isAscending)
  const DescendingIndicator = getIndicatorComponent(isDescending)
  return (
    <div className="sorting-indicator">
      <AscendingIndicator />
      <DescendingIndicator className="descending-icon" />
    </div>
  )
}
